import Icon from '@/ui/components/icons/base-icon'
import TechnologyIcon from '@assets/images/technology-icon.svg?react'
import { FC } from 'react'
import {
    TechnologiesInfoWrapper,
    TechnologyItem,
} from './technologiesInfo.styles'
import Typography from '@/ui/components/typography'

type TechnologiesInfoProps = {
    asset: TAsset
}

const TechnologiesInfo: FC<TechnologiesInfoProps> = ({ asset }) => {
    const { technologies } = asset

    const hasTechnologies = technologies && technologies?.length > 0

    if (!hasTechnologies) {
        return null
    }

    return (
        <TechnologiesInfoWrapper
            className="asset-details asset-details-email"
            data-testid="associated-technologies"
        >
            <Typography variant="l-regular" className="section-title text">
                Associated technologies
            </Typography>
            {technologies?.map(({ id, name }) => {
                return (
                    <TechnologyItem key={id} className="technology-item">
                        <Icon>
                            <TechnologyIcon />
                        </Icon>
                        <Typography
                            variant="s-regular"
                            className="text technology-name"
                            testId="technology-name"
                        >
                            {name}
                        </Typography>
                    </TechnologyItem>
                )
            })}
        </TechnologiesInfoWrapper>
    )
}

export default TechnologiesInfo
